"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _TabsProvider = require("../../TabsProvider");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var TabsHeader = function TabsHeader(_ref) {
  var children = _ref.children,
    value = _ref.value,
    index = _ref.index,
    label = _ref.label;
  var context = (0, _TabsProvider.useTabsContext)();
  if (!context) {
    throw new Error("Tabs isn't wrapped by TabsProvider");
  }
  var activeTab = context.activeTab,
    setActiveTab = context.setActiveTab,
    setActiveTabIndex = context.setActiveTabIndex,
    onChange = context.onChange,
    setOldIndex = context.setOldIndex,
    activeTabIndex = context.activeTabIndex;
  var handleOnClick = function handleOnClick() {
    setActiveTab(value);
    setOldIndex(activeTabIndex);
    setActiveTabIndex(index);
    onChange && onChange(value);
  };
  if (children === undefined) {
    return /*#__PURE__*/_react["default"].createElement(TTabHeaderStyled, {
      selected: activeTab === value,
      onClick: handleOnClick
    }, label);
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    onClick: handleOnClick
  }, children && children({
    selected: activeTab === value
  }));
};
var _default = TabsHeader;
exports["default"] = _default;
var TTabHeaderStyled = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tcolor: ", ";\n\tfont-weight: bold;\n\t/* width: 6.25rem; */\n\ttext-align: center;\n\tfont-size: 0.875em;\n\tmargin: 0px;\n\tcursor: pointer;\n\tline-height: 1.125rem;\n\tpadding: 0.5em 0px;\n\tposition: relative;\n\tmin-width: 5rem;\n\t&::before {\n\t\tdisplay: ", ";\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\theight: 3px;\n\t\twidth: 100%;\n\t\tbackground: rgb(181, 177, 255);\n\t\tleft: 0;\n\t\ttop: 100%;\n\t}\n"])), function (props) {
  return props.theme.colors.purple;
}, function (props) {
  return props.selected ? 'block' : 'none';
});